module.exports = __webpack_public_path__ + "static/media/Low-battery-icon.41f2eef4.svg";